var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNaranjax({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.47,12a.74.74,0,0,0-.58-.32H13.36a.37.37,0,0,0-.3.56l5.63,8.71a.15.15,0,0,1,0,.16l-5.63,8.71a.36.36,0,0,0,.3.56H16.9a.68.68,0,0,0,.56-.3L23,21.49a.91.91,0,0,0,0-1L17.47,12Z",
    fill: "#fe5000",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.09,22.26a.15.15,0,0,0-.25,0L22,25.12a.93.93,0,0,0,0,1L24.5,30a.8.8,0,0,0,.67.37h3.47a.37.37,0,0,0,.3-.56l-4.85-7.53ZM24.5,12,22,15.89a.93.93,0,0,0,0,1l1.84,2.86a.15.15,0,0,0,.25,0l4.85-7.54a.35.35,0,0,0-.29-.55H25.17A.8.8,0,0,0,24.5,12Z",
    fill: "#50007f",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNaranjax);
export default __webpack_public_path__ + "static/media/naranjax.052fb901c7b9d15ff89c931fbe6dc1f6.svg";
export { ForwardRef as ReactComponent };